<div class="{{isWebView?'container-wv':'container'}}">
    <!-- Gap 1: Migrated user re-entry notice -->
    <div *ngIf="hasMigratedLegacyCard" style="
      background: #fff3cd;
      border: 1px solid #ffc107;
      border-radius: 4px;
      padding: 12px 16px;
      margin-bottom: 16px;
      font-size: 14px;
      color: #664d03;">
      <strong>Action required:</strong> Your previous payment method has been migrated to our new payment system.
      Please re-enter your card details below to continue.
    </div>
    <div id="dropin-container">
      <!-- <app-add-new-payment-option></app-add-new-payment-option> -->
    </div>
    <div class="action-btn-container flex justify-content-center">
      <button  mat-flat-button (click)="onCardAddBack()" class="background-red-color standard-btn cancel-btn margin-right-10px">
        <span>Back</span>
      </button>
      <button mat-flat-button (click)="pay()" class="background-red-color standard-btn cancel-btn">
        <span>{{titleBtn}}</span>
      </button>
    </div>
  </div>